"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditablePagesStorage = useEditablePagesStorage;
const shared_1 = require("../../../../backend/features/editable-pages/shared");
const hooks_1 = require("../../../../ui/hooks");
function useEditablePagesStorage() {
    return (0, hooks_1.useStorageClient)(shared_1.editablePageEntityName);
}
